// Get a value
export const getFromRecord = <T>(
  record: Record<string, T[]>,
  key: string
): T[] | undefined => {
  return record[key];
};

// Set a value (replace existing or add new)
export const setInRecord = <T>(
  record: Record<string, T[]>,
  key: string,
  value: T[]
): Record<string, T[]> => {
  return { ...record, [key]: value };
};

// Remove a key
export const removeFromRecord = <T>(
  record: Record<string, T[]>,
  key: string
): Record<string, T[]> => {
  const { [key]: _, ...rest } = record;
  return rest;
};

// Check if key exists
export const hasInRecord = <T>(
  record: Record<string, T[]>,
  key: string
): boolean => {
  return key in record;
};

// Get all keys
export const keysOfRecord = <T>(record: Record<string, T[]>): string[] => {
  return Object.keys(record);
};

// Get all values
export const valuesOfRecord = <T>(record: Record<string, T[]>): T[][] => {
  return Object.values(record);
};

// Get all entries (like Map.entries)
export const entriesOfRecord = <T>(
  record: Record<string, T[]>
): [string, T[]][] => {
  return Object.entries(record);
};

// Update (map) values for a specific key
export const updateInRecord = <T>(
  record: Record<string, T[]>,
  key: string,
  updater: (value: T[] | undefined) => T[]
): Record<string, T[]> => {
  return {
    ...record,
    [key]: updater(record[key]),
  };
};

// Append items to array at key
export const appendToRecord = <T>(
  record: Record<string, T[]>,
  key: string,
  items: T[]
): Record<string, T[]> => {
  return {
    ...record,
    [key]: [...(record[key] ?? []), ...items],
  };
};

// Filter values of a specific key
export const filterInRecord = <T>(
  record: Record<string, T[]>,
  key: string,
  predicate: (item: T) => boolean
): Record<string, T[]> => {
  const existing = record[key];
  if (!existing) return record;
  return {
    ...record,
    [key]: existing.filter(predicate),
  };
};
